import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock } from "lucide-react";
import { resetPassword } from "../actions/userActions";
import { FormInput } from "../components/FormInput";

const PasswordResetScreen = () => {
	const [password1, setPassword1] = useState("");
	const [password2, setPassword2] = useState("");
	const [password1Error, setPassword1Error] = useState("");
	const [password2Error, setPassword2Error] = useState("");
	const [id, setId] = useState(
		window.location.search.replace("?", "").split(",")[0].split("=")[1]
	);
	const [valid, setValid] = useState(
		window.location.search.replace("?", "").split(",")[1].split("=")[1]
	);

	let history = useNavigate();

	const submitHandler = (e) => {
		console.log("submitHandler");
		e.preventDefault();
		if (password1 === password2) {
			resetPassword(id, password1, valid);
			history("/login");
		}
	};

	return (
		<>
			<Helmet>
				<meta name="robots" content="noindex,nofollow" />
			</Helmet>

			<div className="min-h-screen bg-gray-50 flex items-center justify-center px-4 sm:px-6 lg:px-8">
				<div className="max-w-md w-full bg-white p-8 rounded-xl shadow-sm border border-gray-200">
					{/* Header */}
					<div className="text-center mb-8">
						<h2 className="text-3xl font-bold text-gray-900">
							Reset Your Password
						</h2>
						<p className="mt-2 text-gray-600">
							Please enter your new password below
						</p>
					</div>

					{/* Form */}
					<motion.form
						initial={{ opacity: 0, y: 20 }}
						animate={{ opacity: 1, y: 0 }}
						onSubmit={submitHandler}
						className="space-y-6"
					>
						<FormInput
							label="New Password"
							type="password"
							icon={Lock}
							error={password1Error}
							required
							value={password1}
							onChange={(e) => {
								const value = e.target.value;
								if (value.length >= 6 && /\d/.test(value)) {
									setPassword1Error("");
									setPassword1(value);
								} else {
									setPassword1Error(
										"Passwords must be at least 6 characters long and contain a number"
									);
								}
							}}
							placeholder="Enter new password"
						/>
						<FormInput
							label="Confirm Password"
							type="password"
							icon={Lock}
							error={password2Error}
							required
							value={password2}
							onChange={(e) => {
								const value = e.target.value;
								if (value === password1) {
									setPassword2Error("");
									setPassword2(value);
								} else {
									setPassword2Error("Passwords must match");
								}
							}}
							placeholder="Confirm new password"
						/>

						<button
							type="submit"
							className="w-full px-4 py-3 bg-primary text-white font-medium rounded-lg hover:bg-primary/90 transition-colors flex items-center justify-center gap-2"
						>
							Reset Password
						</button>
					</motion.form>

					<div className="mt-8 text-center">
						<Link
							to="/account-recovery"
							className="text-gray-600 hover:text-primary transition-colors"
						>
							Forgot your password?
						</Link>
					</div>
				</div>
			</div>
		</>
	);
};

export default PasswordResetScreen;
